export const INVOICE_RULES = {
  RULE_CCID: "RULE_CCID",
  RULE_SELLER: "RULE_SELLER",
  RULE_BUYER: "RULE_BUYER",
  RULE_UNIT: "RULE_UNIT",
  RULE_CONTENT: "RULE_CONTENT",
  RULE_VAT: "RULE_VAT",
  RULE_VAT_LEAST: "RULE_VAT_LEAST",
  RULE_VAT_MOST: "RULE_VAT_MOST",
  RULE_TOTAL_BEFORE_TAX: "RULE_TOTAL_BEFORE_TAX",
  RULE_TOTAL_BEFORE_TAX_LEAST: "RULE_TOTAL_BEFORE_TAX_LEAST",
  RULE_TOTAL_BEFORE_TAX_MOST: "RULE_TOTAL_BEFORE_TAX_MOST",
  RULE_AMOUNT_OF_DEBT_DAYS: "RULE_AMOUNT_OF_DEBT_DAYS",
  RULE_KIND_OF: "RULE_KIND_OF",
  RULE_PAID_DATE: "RULE_PAID_DATE"
};

export const ROUNDING = {
  TAX_MONEY: "TAX_MONEY",
  TAX_MONEY__FOREIGN: "TAX_MONEY__FOREIGN",
  SUB_TOTAL: "SUB_TOTAL",
  SUB_TOTAL__FOREIGN: "SUB_TOTAL__FOREIGN",
  UNIT_PRICE: "UNIT_PRICE",
  UNIT_PRICE__FOREIGN: "UNIT_PRICE__FOREIGN"
};

export const NOTIFICATION_TYPE = {
  SYNC_PROCESS_0_SUCCESS: 0,
  SYNC_PROCESS_1_SUCCESS: 1,
  SYNC_PROCESS_2_SUCCESS: 2,
  ACCOUNT_CQT_ERROR: 3,
  RELEASE_INVOICE_SUCCESS: 4,
  SYNC_TBPH_SUCCESS: 5,
  SEND_EMAIL_SUCCESS: 6,
  SEND_BCSS_SUCCESS: 7,
  OTHER: 8
};

export const RULE_UNIT = {
  MONTH: "MONTH",
  DAY: "DAY",
  TIMES: "TIMES"
};

export const RULE_KIND_OF = {
  YES: "YES",
  NO: "NO"
};

export const INVOICE_ACTIONS = {
  ADJUST_INFO: "ADJUST_INFO",
  ADJUST_INCREASE_DECREASE: "ADJUST_INCREASE_DECREASE",
  ISSUE_REPLACEMENT_INVOICE: "ISSUE_REPLACEMENT_INVOICE",
  ISSUE_CONVERSION_INVOICE: "ISSUE_CONVERSION_INVOICE",
  DOWNLOAD_CONVERSION_INVOICE: "DOWNLOAD_CONVERSION_INVOICE",
  SEND_TAX: "SEND_TAX",
  // CANCEL_INVOICE: 'CANCEL_INVOICE',
  VIEW_CONVERSION_HISTORY: "VIEW_CONVERSION_HISTORY",
  SEND_EMAIL: "SEND_EMAIL",
  COPY_INVOICE: "COPY_INVOICE",
  EXPLAIN_INVOICE: "EXPLAIN_INVOICE",
  PREPARE_ERROR_REPORT: "PREPARE_ERROR_REPORT",
  ISSUE_INVOICE: "ISSUE_INVOICE",
  DELETE_INVOICE: "DELETE_INVOICE"
};

export const INVOICE_STATUS = {
  ORIGINAL: "ORIGINAL",
  REPLACE: "REPLACE",
  REPLACED: "REPLACED",
  MODIFY: "MODIFY",
  MODIFIED: "MODIFIED",
  CANCELED: "CANCELED",
  DRAFT: "DRAFT"
};

export const ERROR_CODES = {
  APP_NOT_START: "APP_NOT_START",
  APP_NOT_UP_TO_DATE: "APP_NOT_UPTODATE",
  USB_NOT_CONNECT: "USB_NOT_CONNECT",
  TAX_CODE_ERROR: "TAX_CODE_ERROR",
  USB_NOT_ACCESSIBLE: "USB_NOT_ACCESSIBLE",
  RELEASE_INVOICE_FAILED: "RELEASE_INVOICE_FAILED",
  SIGN_INVOICE_FAILED: "SIGN_INVOICE_FAILED",
  CREATE_TMP_INVOICE_FAILED: "CREATE_TMP_INVOICE_FAILED",
  LICENSE_EXPIRED: "LICENSE_EXPIRED",
  REPORT_INVOICE_ERROR_FAILED: "REPORT_INVOICE_ERROR_FAILED", // Báo cáo hóa đơn sai sót thất bại
  TRANSFER_INVOICE_FAILED: "TRANSFER_INVOICE_FAILED" // Chuyển đổi hóa đơn thất bại
};

export const INVOICE_PRODUCT_SERVICE_TABLE_ERROR = context => ({
  // + 'không được bỏ trống'
  EMPTY_TABLE: "Bảng hàng hóa dịch vụ",
  MISSING_NOTE: "Nội dung ghi chú",
  DISCOUNT_INFO: "Thông tin chiết khấu",
  MISSING_METHOD: "Cần chọn Điều chỉnh tăng hoặc giảm trên danh sách hàng hóa",
  NON_NEGATIVE_DECREASE:
    "Dòng hóa đơn GIẢM, cần có số tiền tổng cộng là số âm trên danh sách hàng hóa",
  MISSING_NAME: context.$t("invoice.nameOfGoodsAndServices"),
  MISSING_UNIT: context.$t("invoice.unit"),
  MISSING_QUANTITY: context.$t("invoice.quantity"),
  MISSING_PRICE: context.$t("invoice.price")
});

export const EVENT_BUS = {
  DRIVE_CREATE_INVOICE: "drive-create-invoice"
};

export const PAGE_LIMIT = 10;
export const PAGE_NOTIFICATION_LIMIT = 10;

export const PRODUCT_TYPE = {
  PRODUCT: "HANG_HOA",
  NOTE: "GHI_CHU",
  DISCOUNT: "CHIET_KHAU",
  DECREE: "NGHI_DINH"
};

export const BUYER_TYPE = {
  PERSONAL: "PERSIONAL",
  ENTERPRISE: "ENTERPRISE"
};

export const DEFAULT_TABLE = [
  {
    id: 0,
    stt: null,
    name: null,
    unit: null,
    quantity: null,
    price: null,
    rate: 0,
    tax_money: null,
    subtotal: null,
    total: null,
    type: PRODUCT_TYPE.PRODUCT,
    custom_tax_rate: 0,
    method: null
  }
];

export const DECREE_ROW = id => ({
  id: id,
  stt: null,
  name: null,
  unit: null,
  quantity: null,
  price: null,
  rate: 0,
  tax_money: null,
  subtotal: null,
  total: null,
  type: PRODUCT_TYPE.DECREE,
  custom_tax_rate: 0
});

export const E_INVOICE_ROLE = {
  invoice_draft_management: {
    add: true,
    view: true,
    change: true,
    delete: true
  },
  invoice_management: { add: true, view: true, change: true, delete: true },
  publish_management: { add: true, view: true, change: true, delete: true },
  report: { add: true, view: true, change: true, delete: true },
  setting_management: { add: true, view: true, change: true, delete: true },
  user_management: { add: true, view: true, change: true, delete: true }
};

export const EXTERNAL_URL = `${process.env.P_INVOICE_FRONTEND_URL}/#/notify-create-release?isNewNotify=true`;
export const DOWNLOAD_URL = `${process.env.P_INVOICE_BACKEND_URL}/setting/download_file?url_file=`;

export const GIF_URL = name =>
  `${process.env.ASSETS_URL}/media/seeder/${name}.gif`;

export const PROVIDER_INFORMATION = [
  {
    name: "Hóa đơn điện tử Vĩnh Hy",
    taxCode: "0314743623",
    linkLookup: "http://ehoadondientu.com/Tra-cuu"
  },
  {
    name: "FPT.eInvoice",
    taxCode: "0104128565",
    linkLookup: "https://tracuuhoadon.fpt.com.vn/"
  },
  {
    name: "iHOADON (EFY Việt Nam)",
    taxCode: "0102519041",
    linkLookup: "https://ihoadon.vn/kiem-tra/?lang=vn"
  },
  {
    name: "EasyInvoice (Softdreams)",
    taxCode: "0105987432",
    linkLookup: "https://tracuu.easyinvoice.vn/Search/Index"
  },
  {
    name: "L.C.S Invoice",
    taxCode: "0302999571",
    linkLookup: "https://einvoice.lcs.com.vn"
  },
  {
    name: "KK VAT",
    taxCode: "0313963672",
    linkLookup: "https://tracuuhoadon.kkvat.com.vn/"
  },
  {
    name: "CyberBill (CyberLotus)",
    taxCode: "0105232093",
    linkLookup: "https://tracuuhoadon1.xcyber.vn/#/tracuuhoadon/tracuu"
  },
  {
    name: "Ngô Gia Phát Invoice",
    taxCode: "0311942758",
    linkLookup: "https://tracuuonline78.ngogiaphat.vn/Search"
  },
  {
    name: "Mắt Bão Invoice",
    taxCode: "0302712571",
    linkLookup: "https://matbao.in/tra-cuu-hoa-don/"
  },
  {
    name: "Nacencomm Invoice",
    taxCode: "0103930279",
    linkLookup: "https://hoadon78.nacencomm.vn/tracuuhd.aspx"
  },
  {
    name: "Vinvoice (Megabiz)",
    taxCode: "0105844836",
    linkLookup: "https://tracuu.vinvoice.vn/"
  },
  {
    name: "MISA MEINVOICE",
    taxCode: "0101243150",
    linkLookup: "https://www.meinvoice.vn/tra-cuu/"
  },
  {
    name: "M-Invoice",
    taxCode: "0106026495",
    linkLookup: "https://tracuuhoadon.minvoice.com.vn/tra-cuu-hoa-don"
  },
  {
    name: "E-Invoice (Thái Sơn)",
    taxCode: "0101300842",
    linkLookup: "https://einvoice.vn/tra-cuu"
  },
  {
    name: "eHoaDon Online",
    taxCode: "0306784030",
    linkLookup: "https://ehoadon.online/einvoice/lookup"
  },
  {
    name: "Oinvoice",
    taxCode: "0200638946",
    linkLookup: "https://oinvoice.vn/tracuu/"
  },
  {
    name: "Wininvoice",
    taxCode: "0312303803",
    linkLookup: "https://tracuu.wininvoice.vn/"
  },
  {
    name: "Viettel S-Invoice",
    taxCode: "0100109106",
    linkLookup: "https://vinvoice.viettel.vn/utilities/invoice-search"
  },
  {
    name: "Tax24 E-Invoice",
    taxCode: "0102454468",
    linkLookup: "https://tax24.com.vn/thuedientu/xac-minh-hoa-don"
  },
  {
    name: "New-Invoice",
    taxCode: "0105937449",
    linkLookup: "https://newinvoice.com.vn/tra-cuu/"
  },
  {
    name: "3A Soft",
    taxCode: "0108516079",
    linkLookup: "http://hddt.3asoft.vn/#tracuu"
  },
  {
    name: "Mobifone Invoice",
    taxCode: "0100686209",
    linkLookup: "https://tracuuhoadonvienthong.mobifone.vn/"
  },
  {
    name: "BKAV Ehoadon",
    taxCode: "0101360697",
    linkLookup: "https://tchd.ehoadon.vn/TCHD"
  },
  {
    name: "Asia Invoice",
    taxCode: "0101162173",
    linkLookup: "https://asiainvoice.vn/tra-cuu"
  },
  {
    name: "Vin-Hoadon",
    taxCode: "0401486901",
    linkLookup:
      "https://tracuu.vin-hoadon.com/tracuuhoadon/tracuuxacthuc/tracuuhd"
  },
  {
    name: "VNPT Invoice",
    taxCode: "0100684378",
    linkLookup: "https://xemhoadon.vnpt.vn/Portal/SearchToken"
  },
  {
    name: "Hilo Invoice",
    taxCode: "0106713804",
    linkLookup: "https://tracuuhddt78.hilo.com.vn/"
  },
  {
    name: "VNInvoice",
    taxCode: "0101352495",
    linkLookup: "https://tracuu.v50.vninvoice.vn/"
  },
  {
    name: "VNPAY Invoice",
    taxCode: "0102182292",
    linkLookup: "https://portal.vnpayinvoice.vn/"
  },
  {
    name: "VietInvoice (ICORP)",
    taxCode: "0106870211",
    linkLookup: "https://tracuu.vietinvoice.vn/#/"
  },
  {
    name: "Q-Invoice (idocNet)",
    taxCode: "0104614692",
    linkLookup: "https://hoadontvan.com/TraCuu"
  },
  {
    name: "SmartSign",
    taxCode: "0309612872",
    linkLookup: "https://tracuuhd.smartsign.com.vn/"
  },
  {
    name: "TS24 - XuatHoadon",
    taxCode: "0309478306",
    linkLookup: "https://tracuu.xuathoadon.vn/"
  },
  {
    name: "Fast e-Invoice",
    taxCode: "0100727825",
    linkLookup: "https://invoice.fast.com.vn/tra-cuu-hoa-don-dien-tu/"
  },
  {
    name: "HT Invoice",
    taxCode: "0315638251",
    linkLookup: "https://laphoadon.htinvoice.vn/TraCuu"
  },
  {
    name: "CloudInvoice (ITT)",
    taxCode: "0105958921",
    linkLookup: "https://tracuu.cloudinvoice.vn/"
  },
  {
    name: "Hoadon30s",
    taxCode: "0302431595",
    linkLookup: "https://tracuu.hoadon30s.vn/"
  },
  {
    name: "My-Invoice",
    taxCode: "0106820789",
    linkLookup: "https://tracuu.hoadondientuvn.info/#/tracuuhoadon/tracuu"
  },
  {
    name: "SAFEinvoice",
    taxCode: "0310151055",
    linkLookup: "https://invoice.safecert.com.vn/#lookup"
  },
  {
    name: "Liên Sơn Invoice",
    taxCode: "0301452923",
    linkLookup: "https://tracuu.lienson.vn/#/tracuuhoadon/tracuu"
  },
  {
    name: "Hóa đơn điện tử Tia Lửa Việt",
    taxCode: "0303609305",
    linkLookup: "https://ihoadondientu.com/Tra-cuu"
  },
  {
    name: "P-Invoice (PVS)",
    taxCode: "0315151651",
    linkLookup: "https://ei.pvssolution.com/#/"
  },
  {
    name: "KiotViet Hóa đơn điện tử",
    taxCode: "0104359717",
    linkLookup: "https://tracuuhoadon.kiotviet.vn/"
  },
  {
    name: "Haravan E-Invoice",
    taxCode: "0312662961",
    linkLookup: "https://e-invoices.haravan.app/Invoice/Search"
  },
  {
    name: "iPOS Invoice",
    taxCode: "0104789847",
    linkLookup: "https://tracuuhoadon.ipos.vn/"
  },
  {
    name: "Intrust Invoice",
    taxCode: "0110333410",
    linkLookup: "https://lookupeinvoice.intrustdss.vn/"
  },
  {
    name: "Yoyoin (School Tech)",
    taxCode: "0317509886",
    linkLookup: "https://yoyoin.yoyoschool.vn/tra-cuu"
  },
  {
    name: "Sapo Invoice",
    taxCode: "0103243195",
    linkLookup: "https://www.sapo.vn/tra-cuu-sapo-invoice.html"
  },
  {
    name: "VETC Invoice",
    taxCode: "0106858609",
    linkLookup: "https://tracuuhoadon.vetc.com.vn/"
  },
  {
    name: "Bizzi Invoice",
    taxCode: "0316114998",
    linkLookup: "https://tchd.bizzi.vn/"
  },
  {
    name: "Kaike Invoice (GMO)",
    taxCode: "0101659906",
    linkLookup: "https://tracuu.kaike.vn/#/"
  },
  {
    name: "Sơn Phát Invoice",
    taxCode: "4601328480",
    linkLookup: "https://tracuuhoadon.sonphat.vn/"
  },
  {
    name: "AutoInvoice (TADU)",
    taxCode: "0313253288",
    linkLookup: "https://tracuu.autoinvoice.vn/"
  },
  {
    name: "MyInvoice (My Software)",
    taxCode: "0108971656",
    linkLookup: "https://tracuu.myinvoice.vn/#/"
  },
  {
    name: "iHoadonDientu.net (HT Sài Gòn)",
    taxCode: "0312942260",
    linkLookup: "https://ihoadondientu.net/Tracuu.aspx"
  },
  {
    name: "Webcash E-Invoice",
    taxCode: "1201496252",
    linkLookup: "https://einvoicepro.webcashvietnam.com/lookup-einvoice"
  },
  {
    name: "E-Invoices.vn (Kim Tự Tháp)",
    taxCode: "0303549303",
    linkLookup: "https://e-invoices.vietabank.com.vn/User/VABSearch"
  },
  {
    name: "Lạc Việt Accnet",
    taxCode: "0301448733",
    linkLookup: "https://accnet.vn/tra-cuu-hoa-don-dien-tu"
  },
  {
    name: "Hóa đơn điện tử Bách Khoa (PMBK)",
    taxCode: "0202029650",
    linkLookup: "https://hdbk.pmbk.vn/tra-cuu-hoa-don"
  }
];

export default {
  RULE_UNIT,
  RULE_KIND_OF,
  INVOICE_RULES,
  INVOICE_STATUS,
  INVOICE_ACTIONS,
  ERROR_CODES,
  EVENT_BUS,
  PAGE_LIMIT,
  PAGE_NOTIFICATION_LIMIT,
  PRODUCT_TYPE,
  BUYER_TYPE,
  NOTIFICATION_TYPE,
  DEFAULT_TABLE,
  E_INVOICE_ROLE,
  EXTERNAL_URL,
  DOWNLOAD_URL,
  GIF_URL,
  PROVIDER_INFORMATION,
  INVOICE_PRODUCT_SERVICE_TABLE_ERROR,
  DECREE_ROW
};



// WEBPACK FOOTER //
// ./src/app-constant.js